import React from "react";
import { Navigate, useLocation } from "react-router-dom";


const Products = () => {

  const location = useLocation();

  return (
    <Navigate to="/catalog" replace state={{ from: location }} />
  );

};

export default Products;
